import { theme } from "tailwind.config";
import LimitFunctionTableHead from "@/components/LimitFunctionTableHead";
import LimitFunctionRowTableHead from "@/components/LimitFunctionTableRowHead";
import LimitFunctionTableTableData from "@/components/LimitFunctionTableTableData";
import ImportantMessage from "@/components/ImportantMessage";

const TrClass = "border-b border-gray-200";

const LimitFunctionTable = () => {
  return (
    <div className="space-y-24">
      <table>
        <thead>
          <tr className={TrClass}>
            <th></th>
            <LimitFunctionTableHead
              name="PRO"
              target="建築・インテリアの方が対象"
              bgColor={theme.colors.yellow[500]}
            />
            <LimitFunctionTableHead
              name="一般"
              target="どなたでも登録可能"
              bgColor={theme.colors.gray[200]}
            />
          </tr>
        </thead>
        <tbody>
          <tr
            className={TrClass}
            style={{
              height: 80,
            }}
          >
            <LimitFunctionRowTableHead title="事例やプロダクトをまとめるリストの作成" />
            <LimitFunctionTableTableData
              checked={true}
              bgColor={theme.colors.yellow[200]}
            />
            <LimitFunctionTableTableData checked={true} />
          </tr>

          <tr
            className={TrClass}
            style={{
              height: 80,
            }}
          >
            <LimitFunctionRowTableHead title="事例やプロダクトに対してのいいね" />
            <LimitFunctionTableTableData
              checked={true}
              bgColor={theme.colors.yellow[200]}
            />
            <LimitFunctionTableTableData checked={true} />
          </tr>

          <tr
            className={TrClass}
            style={{
              height: 80,
            }}
          >
            <LimitFunctionRowTableHead title="プロダクトのサンプル請求" />
            <LimitFunctionTableTableData
              checked={true}
              bgColor={theme.colors.yellow[200]}
            />
            <LimitFunctionTableTableData checked={false} />
          </tr>

          <tr
            className={TrClass}
            style={{
              height: 80,
            }}
          >
            <LimitFunctionRowTableHead
              title="プロジェクトの投稿"
              notes="※別途、設計事務所の登録申請が必要です"
            />
            <LimitFunctionTableTableData
              checked={true}
              bgColor={theme.colors.yellow[200]}
            />
            <LimitFunctionTableTableData checked={false} />
          </tr>
          <tr
            className={TrClass}
            style={{
              height: 80,
            }}
          >
            <LimitFunctionRowTableHead title="メーカーへの問い合わせ" />
            <LimitFunctionTableTableData
              checked={true}
              bgColor={theme.colors.yellow[200]}
            />
            <LimitFunctionTableTableData checked={false} />
          </tr>
        </tbody>
      </table>

      <ImportantMessage
        message={
          <>
            今後の新しい機能も、
            <span className="font-bold">PROアカウントを優先的に追加</span>
            します。
            <br />
            ぜひ、建築・インテリアデザイン従事者の方はPROアカウントをご利用ください。
          </>
        }
      />
    </div>
  );
};
export default LimitFunctionTable;
